import { HIDE_CHILD, SHOW_CHILD } from '@eventbrite/legacy-eds.hot-keys';

// See https://craig.is/killing/mice for available patterns of declaring keyboard sequences.
export const ACTION_KEY_MAP = {
    // action(str) : keyCombination
    [HIDE_CHILD]: ['esc', 'tab'],
    [SHOW_CHILD]: ['down', 'space', 'enter'],
};
